








































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath, openDownloadDialog, sheet2blob} from "@/shared/services/helper/utils";
import XLSX from "xlsx";
import ReceiptCustomerPickingListPrint from "@/modules/receiptsexpenses/receiptcustomer/shared/Print/index.vue";
import ReceiptCustomerPickingListExcel from "@/modules/receiptsexpenses/receiptcustomer/shared/Excel/index.vue";
@Component({
    name: "ReceiptCustomerPickingListDetail",
    components: {
        ReceiptCustomerPickingListExcel,
        ReceiptCustomerPickingListPrint}
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible",{ type: Boolean, default: false }) syncVisible!: boolean;
    @Prop({ required: true }) id!: any;

    printPickingListObj: Options = {
        id: 'print-picking-list-receipt-customer',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    printPickingList() {
        this.$print(this.printPickingListObj);
    }

    exportExcel() {
        const table1 = document.querySelector("#table-excel-receipt-customer");
        const opt = {
            raw: true
        };
        const sheet = XLSX.utils.table_to_sheet(table1);
        openDownloadDialog(sheet2blob(sheet, 'Bảng kê'), 'BK.xlsx')
    }
}
